<template>
  <main class="app-main" v-bar="{
      useScrollbarPseudo: true,
      overrideFloatingScrollbar: true,
    }">
    <section class="work-area--report" id="top">
      <div class="graphic-wrap">
        <dynamic-chart id="printing" @onGetPeriod="getPeriod"></dynamic-chart>
      </div>
    </section>
  </main>
</template>

<script>
//  components
import DynamicChart from './components/graphics/DynamicChart.vue';

// mixins
import printReportMixin from './mixins/printReport';

// vuex
import { SET_INNER_PAGE } from '../../store/actions/pages';

export default {
  name: "Report",
  data() {
    return {
      name: '',
    };
  },
  beforeRouteLeave (to, from, next) {
    this.$store.dispatch(SET_INNER_PAGE, '');
    next();
  },
  components: {
    DynamicChart,
  },
  mounted() {
    this.$store.dispatch(SET_INNER_PAGE, this.$route.name);
  },
  mixins: [
    printReportMixin,
  ],
};
</script>

<style>
@import "./css/style.css";
</style>
